import { openModal } from "action/modal/openModal";
import TireSeasonIcon from "component/design-system/badge/TireSeasonIcon";
import PAImage from "component/design-system/images/PAImage";
import { useTranslation } from "next-i18next";
import { memo } from "react";
import { useDispatch } from "react-redux";
import openLiveChat from "util/chat-widget/open-live-chat";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./WarrantyReturnPolicyDesktop.module.scss";

function WarrantyReturnPolicyDesktop(props: any) {
  const { season } = props;
  const { t } = useTranslation("product");
  const dispatch = useDispatch();

  return (
    <div style={{ width: "100%", display: "flex" }}>
      <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>

        {season && <TireSeasonIcon season={season} width={34} height={34} />}

        <div onClick={() => dispatch(openModal("warrantyModal"))}>
          <span className={`text-center  ${styles.badge_container}`}>
            <PAImage
              alt="pa warranty"
              src={getRelativeImagePath("/images/Warranty Original.svg")}
              width={40}
              height={40}
            />
            <span className={styles.link_text}>{t("Warranty")}</span>
          </span>
        </div>

        <div onClick={() => dispatch(openModal("returnPolicyModal"))}>
          <span className={`text-center  ${styles.badge_container}`}>
            <PAImage
              alt="pa warranty"
              src={getRelativeImagePath("/images/Returns Original.svg")}
              width={40}
              height={40}
            />
            <span className={styles.link_text}>{t("Return Policy")}</span>
          </span>
        </div>

        <div className={`text-center  ${styles.badge_container}`}>
          <PAImage
            alt="pa warranty"
            src={getRelativeImagePath("/images/Chat Now Orignial.svg")}
            width={40}
            height={40}
            onClick={() => openLiveChat()}
          />
          <span className={styles.link_text}>{t("Chat now")}</span>
        </div>
      </div>
    </div>
  );
}

export default memo(WarrantyReturnPolicyDesktop);
